import { render, staticRenderFns } from "./MergeProducts.vue?vue&type=template&id=453e1565&scoped=true"
import script from "./MergeProducts.vue?vue&type=script&lang=js"
export * from "./MergeProducts.vue?vue&type=script&lang=js"
import style0 from "./MergeProducts.vue?vue&type=style&index=0&id=453e1565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e1565",
  null
  
)

export default component.exports